/** @typedef {import('../shared/types').OverlayGroupDefinition} OverlayGroupDefinition */
import { getUnsafeFn } from "../shared/functions";
import { AlertsOverlay } from "./alerts";
import { BallPitOverlay } from "./ball-pit";
import { DonationTrainOverlay } from "./donation-train";
import { DonorListOverlay } from "./donor-list";
import { GiftsThatGiveOverlay } from "./gifts-that-give";
import { LeaderboardOverlay } from "./leaderboard";
import { MilestoneOverlay } from "./milestone";
import { PollOverlay } from "./poll";
import { RewardsOverlay } from "./rewards";
import { TextToSpeechOverlay } from "./tts";
export const _Overlays = {
    alerts: AlertsOverlay,
    ballPit: BallPitOverlay,
    donationTrain: DonationTrainOverlay,
    donorList: DonorListOverlay,
    giftsThatGive: GiftsThatGiveOverlay,
    leaderboard: LeaderboardOverlay,
    milestone: MilestoneOverlay,
    poll: PollOverlay,
    rewards: RewardsOverlay,
    tts: TextToSpeechOverlay,
};
export const PlayliveOverlays = {
    ..._Overlays,
    get: (key) => {
        return _Overlays[key];
    },
    getAll: () => {
        return Object.values(_Overlays);
    },
    getUnsafe: (slugOrKey) => {
        return getUnsafeFn(PlayliveOverlays.slugs(), _Overlays, slugOrKey);
    },
    slugs: () => {
        return PlayliveOverlays.getAll().map((overlay) => overlay.slug);
    },
};
/** @typedef {OverlayGroupDefinition<OverlayKey> & OverlayMap} OverlayGroup */
/** @typedef {keyof OverlayMap} OverlayKey */
/** @typedef {typeof _Overlays} OverlayMap */
//# sourceMappingURL=index.js.map